import axios from "axios";
import React from "react";
import LabelledSpinner from "../components/LabelledSpinner"

class QuoteRequestForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            phone: "",
            description: "",
            referral: "",
            file: "",
            loading: false,
            error: false,
            missingFields: false,
            success: false
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleUploadButtonClick = this.handleUploadButtonClick.bind(this)
        this.submitRequest = this.submitRequest.bind(this);

        this.uploadButtonRef = React.createRef();
    }

    submitRequest(e) {
        e.preventDefault();
        this.trigger_loading()
        for (let field of ["name", "email", "phone", "description"]) {
            if (this.state[field] === "") {
                this.trigger_missing_fields_banner();
                return
            }
        }
        let form_data = new FormData()
        form_data.append("name", this.state.name)
        form_data.append("email", this.state.email)
        form_data.append("phone", this.state.phone)
        form_data.append("description", this.state.description)
        form_data.append("referral", this.state.referral)
        if (this.state.file) {
            form_data.append("file", this.state.file)
        }
        axios({
            method: "post",
            url: "/quote_api",
            data: form_data,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(response => {
            if (response.data.success) {
                this.trigger_success_banner()
                this.setState({
                    name: "",
                    email: "",
                    phone: "",
                    description: "",
                    file: "",
                    referral: "",
                })
            } else {
                this.trigger_error_banner()
            }
        }).catch(_ => {
            this.trigger_error_banner()
        })
    }

    trigger_loading() {
        this.setState({
            loading: true,
            error: false,
            success: false,
            missingFields: false,
        }, _ => {
            this.render()
        })
    }

    trigger_error_banner() {
        this.setState({
            loading: false,
            error: true,
            success: false,
            missingFields: false,
        }, _ => {
            this.render()
            this.clear_banners_after_delay()
        })
    }
    trigger_missing_fields_banner() {
        this.setState({
            loading: false,
            error: false,
            success: false,
            missingFields: true,
        }, _ => {
            this.render()
            this.clear_banners_after_delay()
        })
    }

    trigger_success_banner() {
        this.setState({
            loading: false,
            success: true,
            error: false,
            missingFields: false,
        }, _ => {
            this.render()
            this.clear_banners_after_delay()
        })
    }

    clear_banners_after_delay() {
        setTimeout(_ => {
            this.setState({
                loading: false,
                error: false,
                success: false,
                missingFields: false,
            })
            this.render()
        }, 5000)  // 5 second delay
    }

    handleChange(e) {
        const changed_field = e.target.name;
        const new_value = e.target.value;

        this.setState({
            [changed_field]: new_value
        })
    }

    handleFileChange(e) {
        this.setState({
            file: e.target.files[0]
        })
    }

    handleUploadButtonClick(_) {
        this.uploadButtonRef.current.click()
    }

    render() {
        return (
            <div>
                <div>
                    <form onSubmit={this.submitRequest}>
                        <div className="form-group">
                            <label htmlFor="name">Name</label>
                            <input type="text" className="form-control" id="name" name="name" placeholder="Enter your name" value={this.state.name} onChange={this.handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email address</label>
                            <input type="email" className="form-control" id="email" name="email" placeholder="Enter email" value={this.state.email} onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Phone Number</label>
                            <input type="text" className="form-control" id="phone" name="phone" placeholder="Enter phone number" value={this.state.phone} onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="referral">Referral</label>
                            <input type="referral" className="form-control" id="referral" name="referral" placeholder="Enter referral (optional)" value={this.state.referral} onChange={this.handleChange} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="description">Description</label>
                            <textarea className="form-control" placeholder="Enter description" id="description" name="description" value={this.state.description} onChange={this.handleChange} ></textarea>
                        </div>
                        {this.state.file && <p>Photo selected</p>}
                        <input type="file" onChange={this.handleFileChange} hidden={true} ref={this.uploadButtonRef} accept="image/jpeg" />
                        <button type="button" className="btn btn-secondary" onClick={this.handleUploadButtonClick}>Add Photo</button>
                        <button type="submit" className="btn btn-primary" onClick={ this.submitRequest }>Submit</button>
                    </form>
                </div>
                { this.state.loading && <LabelledSpinner label="Submitting" /> }
                { this.state.error && <p style={{ color: "red" }}>Something went wrong</p> }
                { this.state.missingFields && <p style={{ color: "red" }}>Missing required fields</p> }
                { this.state.success && <p style={{ color: "green" }}>Submitted</p> }
            </div>
        )
    }
}

export default QuoteRequestForm